import API from "@/api/index"
import util from "@/mixins/util";
import { param } from "jquery";

class ItemRegister {
    getCreateClassConstants() {
        let CreateClassConstants = {
            ApiDataDefine: {
                i_type: 'eot',
                i_display: 0,
                i_name: '',
                i_use: 1,
                ie_manufacture_date: "9999-12-31",
            },
        }
        return CreateClassConstants
    }

    makeParams(params) {
        let resultParams = this.getCreateClassConstants().ApiDataDefine;
        resultParams = Object.assign({}, resultParams, params);
        return resultParams;
    }

    getResultData(res, resultData) {
        // if(res.hasOwnProperty('Info')) {
        //     resultData.type = res.Info.Type;
        // }
        if(res.hasOwnProperty('List')) {
            resultData.resultData = res.List;
            resultData.type = res.List.Data.Status
        }
        if(res.hasOwnProperty('List') && res.List.hasOwnProperty('Data') &&
            res.List.Data.hasOwnProperty('Data') && res.List.Data.Data.hasOwnProperty('Basic') &&
            res.List.Data.Data.Basic.hasOwnProperty('Data') && res.List.Data.Data.Basic.Data.hasOwnProperty('Item') &&
            res.List.Data.Data.Basic.Data.Item.hasOwnProperty('Data') && res.List.Data.Data.Basic.Data.Item.Data.hasOwnProperty('i_idx')) {

            resultData.key = res.List.Data.Data.Basic.Data.Item.Data.i_idx;
            resultData.optionKey = res.List.Data.Data.Basic.Data.Item.Data.io_idx;
        }

        /*if(res.hasOwnProperty('List') && res.List.hasOwnProperty('Data') &&
            res.List.Data.hasOwnProperty('Data') && res.List.Data.Data.hasOwnProperty('Basic') &&
            res.List.Data.Data.Basic.hasOwnProperty('Data') && res.List.Data.Data.Basic.Data.hasOwnProperty('ItemOption') &&
            res.List.Data.Data.Basic.Data.ItemOption.hasOwnProperty('Data') && res.List.Data.Data.Basic.Data.ItemOption.Data.hasOwnProperty('io_idx')
            && !util.isEmpty(res.List.Data.Data.Basic.Data.ItemOption.Data.io_idx)){
            resultData.optionKey = res.List.Data.Data.Basic.Data.ItemOption.Data.io_idx[0];
        }*/
        // if(resultData.type === 1) {
        //     resultData.type = true;
        // }
        return resultData
    }

    getApiMethod(itemKey) {
        if(itemKey != null) {
            return API.$item.updateItem
        }
        return API.$item.createItem
    }
}

class ItemClass {
    User = null;
    UserKey = 'mb_no';
    CategoryAllList = [];

    itemKey = '';
    beforeBrandKey = null;
    beforeBrandMainKey = null;

    constructor(ItemUser) {
        let User = ItemUser || null,
            UserKey = ItemUser[this.getItemClassConstants().UserKey] || null

        this.User = User;
        this.UserKey = UserKey;
    }
    getItemClassConstants() {
        let ItemClassConstants = {
            ResultData: {key: null, type: -1, resultData: {}},
            UserKey: 'mb_no',
            ItemKey: 'i_idx',
        }
        return ItemClassConstants;
    }
    _getOrderType(type) {
        let writeClass = null;
        if(type === 'create') {
            writeClass = new ItemRegister()
        }
        return writeClass
    }

    _checkAbleWriteUser() {
        if(util.isEmpty(this.User)) {
            return false;
        }
        return true;
    }

    _getItemKey(params) {
        let itemKey = this.getItemClassConstants().ItemKey;
        if(params.hasOwnProperty(itemKey)) {
            return params[itemKey]
        }
        return null;
    }

    runWrite(type, data) {
        let writeClass = this._getOrderType(type);
        let resultData = this.getItemClassConstants().ResultData
        return new Promise(async resolve => {
            if(!this._checkAbleWriteUser()) {
                resolve(resultData)
                return false;
            }
            if (writeClass == null) {
                resolve(resultData)
                return false;
            }
            let params = writeClass.makeParams(data)
            let itemKey = this._getItemKey(params)
            let func = writeClass.getApiMethod(itemKey)
            func(params).then(res => res.Data.Result).then( res => {
                let resData = writeClass.getResultData(res, resultData);
                resolve(resData)
            })
        })
    }

    _getItemBasicData(itemData, resultData) {
        // resultData.itemKey = itemData.i_idx;
        resultData.name = itemData.i_name;
        resultData.fitting = itemData.i_fitting;
        resultData.display = itemData.i_display;
        resultData.gender = itemData.i_gender;
        resultData.memo = itemData.i_memo;
        resultData.manageCode = itemData.i_model;
        resultData.price = itemData.i_price_org;
        resultData.discount = itemData.i_price
        resultData.priceOrg = itemData.i_price_org;
        resultData.sku = itemData.i_sku;
        resultData.selling = itemData.i_is_selling;
        resultData.discountUse = itemData.i_is_sale;
        resultData.brandKey = itemData.b_idx;
        resultData.brandName = itemData.i_brand;
        return resultData;
    }

    _getItemCategoryData(itemData, resultData) {
        resultData.category = itemData.ic_idx;
        return resultData;
    }

    _getItemEotData(itemData, resultData) {
        resultData.bottomType = itemData.ie_bottom_type;
        resultData.season = itemData.ie_season;
        resultData.link = itemData.ie_link;
        resultData.nCategory = itemData.ie_n_category_num;
        resultData.nDibs = itemData.ie_n_dibs;
        resultData.nRank = itemData.ie_n_rank;
        resultData.nReview = itemData.ie_n_review;
        resultData.nSearchWord = itemData.ie_n_search_word;
        resultData.pattern = itemData.ie_pattern;
        return resultData
    }

    _getItemOptionData(itemData, resultData) {
        resultData.optionKey = itemData.io_idx;
        resultData.color = itemData.io_color;
        resultData.tone = itemData.io_tone;
        return resultData;
    }

    _getItemStockOptionData(itemData, resultData) { //옵션/재고 미완성
        resultData.optionList = itemData.Option;
        resultData.optionUse = itemData.i_is_option
        resultData.stockUse = itemData.ist_use
        resultData.stock = itemData.ist_stock
        return resultData;
    }

    _getItemImageData(itemData, resultData) {
        resultData.itemImage = [];
        if(!util.isEmpty(itemData.File)) {
            resultData.itemImage = itemData.File.filter(file => file.a_idx != null);
        }
        resultData.itemOptionImage = [];
        if(!util.isEmpty(itemData.optionFile)) {
            resultData.itemOptionImage = itemData.optionFile.filter(file => file.a_idx != null);
            // resultData.itemOptionImage = itemData.File.filter(file => file.a_idx != null);
        }
        resultData.detailImage = [];
        if(!util.isEmpty(itemData.Detail)) {
            resultData.detailImage = itemData.Detail.filter(file => file.a_idx != null);
        }
        resultData.smartFittingImage = [];
        if(!util.isEmpty(itemData.Fitting)) {
            resultData.smartFittingImage = itemData.Fitting.filter(file => file.a_idx != null);
        }
        return resultData;
    }

    _getItemBrandData(itemData, resultData) { //연결된 브랜드가 있는 경우
        if(!util.isEmpty(itemData.brandInfo)) {
            resultData.brandData = itemData.brandInfo;
        } else {
            resultData.brandData = {}
        }
        return resultData;
    }

    getItemData(itemData) {
        let resultData = {};
        resultData = this._getItemBasicData(itemData, resultData);
        resultData = this._getItemCategoryData(itemData, resultData);
        resultData = this._getItemEotData(itemData, resultData);
        resultData = this._getItemOptionData(itemData, resultData);
        resultData = this._getItemImageData(itemData, resultData);
        resultData = this._getItemStockOptionData(itemData, resultData)
        resultData = this._getItemBrandData(itemData, resultData)
        return resultData;
    }


    // 브랜드

    setBeforeBrand(brandData={}) {
        if(brandData.hasOwnProperty('b_idx')) {
            this.beforeBrandKey = brandData.b_idx ?? null;
        }
        if(brandData.hasOwnProperty('main') && brandData.main.length > 0) {
            this.beforeBrandMainKey = brandData.main[0].bmi_idx ?? null;
        }
    }

    _removeBrand(itemKey, brandKey){
        return new Promise(async resolve => {
            if(brandKey != this.beforeBrandKey && this.beforeBrandKey != null) {
                let params = {
                    i_idx: [itemKey],
                }
                try {
                    API.$item.deleteBrand(params).then(res => res.Data.Result).then(resData => {
                        resolve(resData)
                    })
                } catch (e) {
                    console.log(e);
                }
            }else {
                resolve(true)
            }
        })
    }

    _addBrand(itemKey, brandKey){
        return new Promise(async resolve => {
            console.log(brandKey)
            if(brandKey != null && brandKey != this.beforeBrandKey) {
                let params = {
                    i_idx: [itemKey],
                    b_idx: brandKey,
                }
                try {
                    API.$item.createBrand(params).then(res => res.Data.Result).then(resData => {
                        resolve(resData)
                    })
                } catch (e) {
                    console.log(e);
                }
            }else {
                resolve(true)
                return ;
            }
        });
    }

    _removeBrandMain(itemKey, brandKey, isMain=false){
        return new Promise(async resolve => {
            if(!this.beforeBrandMainKey) {
                resolve(true)
                return ;
            }
            if(!isMain || brandKey != this.beforeBrandKey) {
                let params = {
                    bmi_idx: [this.beforeBrandMainKey]
                }
                API.$item.deleteBrandMain(params).then(res => res.Data.Result).then(resData => {
                    resolve(resData)
                })
            }else{
                resolve(true)
            }
        })
    }

    _isAddBrandMain(itemKey, brandKey, isMain=false) {
        if(this.beforeBrandMainKey == null && isMain) {
            return true;
        }
        if(brandKey != this.beforeBrandKey && isMain) {
            return true;
        }
        return false;
    }

    _addBrandMain(itemKey, brandKey, isMain=false){
        return new Promise(async resolve => {
           if(!this._isAddBrandMain(itemKey, brandKey, isMain)) {
               resolve(true)
               return null;
           }
           let params = {
               b_idx: brandKey,
               i_idx: [itemKey]
           }
            try {
                API.$item.createBrandMain(params).then(res => res.Data.Result).then(resData => {
                    resolve(resData)
                })
            } catch (e) {
                console.log(e);
            }
        });
    }

    async saveBrandInfo(itemKey, brandKey, isMain){
        let resultData = {}
        resultData.removeBrand = await this._removeBrand(itemKey, brandKey);
        resultData.addBrand = await this._addBrand(itemKey, brandKey);
        resultData.removeBrandMain = await this._removeBrandMain(itemKey, brandKey, isMain);
        resultData.addBrandMain = await this._addBrandMain(itemKey, brandKey, isMain);
        return resultData;
    }
}

export default {
    ItemClass: ItemClass,
}
